import {remCalc} from '_themeUtils'

const navigationStylesCommons = {
    height: 'auto',
    mt: 0,
    p: 'spacing.1',
    color: 'color.icon.black',
    cursor: 'pointer',
    zIndex: 0,
    top: `calc(50% - ${remCalc(55)}/2)`,
    transform: 'translateY(-50%)',
    _after: {
        display: 'none',
    },
}

const doubleSameItem = {
    DoubleSameItem: {
        baseStyle: ({hasProductsCarousel}) => ({
            wrapper: {
                py: 'spacing.8',
                gap: remCalc(0),
                px: {base: '6%', md: '20%', xl: '25%'},
                height: '100%',
                justifyContent: 'center',
            },
            containerItem: {
                px: remCalc(15),
                mx: 'auto',
                w: {base: '100%', xl: '92%'},
                maxW: remCalc(1950),
            },
            body: {
                h: remCalc(100),
                alignItems: 'center',
                gap: remCalc(0),
                display: 'none',
                justifyContent: 'center',
                textAlign: 'center',
            },
            title: {
                textStyle: {base: hasProductsCarousel ? 'paragraphLg' : 'displayXs', md: 'displayXs'},
                fontWeight: 400,
                fontFamily: 'GTEesti',
                pb: 'spacing.2',
            },
            text: {
                textStyle: {base: 'paragraphSm', md: hasProductsCarousel ? 'paragraphMd' : 'paragraphLg'},
                pb: 'spacing.4',
                fontWeight: 350,
            },
            navigationPrev: {
                ...navigationStylesCommons,
                left: {base: '-spacing.6', md: '-spacing.8'},
            },
            navigationNext: {
                ...navigationStylesCommons,
                right: {base: '-spacing.6', md: '-spacing.8'},
            },
            container: {
                mx: `-${remCalc(13)}`,
                position: 'relative',
                overflow: 'visible',
            },
        }),
    },
}

export default doubleSameItem
